import React from "react";
import { WebComponentsPageContent } from "./";

export const WebComponentsPage = () => {
  return <WebComponentsPageContent></WebComponentsPageContent>;
};
